module.exports = "<div class=\"as-structure\">\r\n  <div class=\"as-charts\">\r\n    <div #state [id]=\"statesChartId\" class=\"as-pie-chart\"></div>\r\n    <hr />\r\n    <div #balance [id]=\"balanceChartId\" class=\"as-pie-chart\"></div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/components/assortment-structure.component/assortment-structure.component.html
// module id = ./src/app/buffer-graph/components/assortment-structure.component/assortment-structure.component.html
// module chunks = main